import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import cs from "classnames";
import React from "react";
import { maxWidthWithPx } from "../utils";
export function PageContainer(_param) {
    var children = _param.children, _floatingElement = _param.floatingElement, floatingElement = _floatingElement === void 0 ? null : _floatingElement, _style = _param.style, style = _style === void 0 ? {} : _style, _dontContain = _param.dontContain, dontContain = _dontContain === void 0 ? false : _dontContain, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "children",
        "floatingElement",
        "style",
        "dontContain",
        "className"
    ]);
    if (floatingElement) {
        dontContain = true;
    }
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            contain: dontContain ? "initial" : "paint"
        },
        className: classNames("w-full max-w-full relative flex flex-col items-center "),
        children: [
            floatingElement && /*#__PURE__*/ _jsx("div", {
                className: cs("absolute flex flex-col items-center justify-center", "w-full z-0 inset-0"),
                children: floatingElement
            }),
            /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                className: classNames("flex flex-col w-full min-w-0 h-auto items-stretch", className),
                style: _object_spread({
                    // margin: '0 auto',
                    position: floatingElement ? "relative" : "static",
                    maxWidth: maxWidthWithPx()
                }, style)
            }, rest), {
                children: children
            }))
        ]
    });
}
export function RootPageContainer(_param) {
    var children = _param.children, _style = _param.style, style = _style === void 0 ? {} : _style, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "children",
        "style",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        style: {
            contain: "paint"
        },
        className: classNames("relative min-h-full max-w-full items-stretch overflow-x-hidden", "flex-col flex space-y-[30px] md:space-y-[60px]", className)
    }, rest), {
        children: children
    }));
}
